export class Tab {
  name: string;
  value: string;
  isHidden: boolean;

  constructor(name: string, value: string, isHidden = false) {
    this.name = name;
    this.value = value;
    this.isHidden = isHidden;
  }
}
